import emojies_shortcuts from 'markdown-it-emoji/lib/data/shortcuts';
import bare_emoji_plugin from 'markdown-it-emoji/bare';
import {emojiDefinitions} from '../helper/emoji';

export const markdownEmoji = md => bare_emoji_plugin(md, {
  defs: emojiDefinitions.reduce(function(map, emojiDefinition) {
    emojiDefinition.shortcodes.forEach(alias => {
      map[alias] = emojiDefinition.unicode;
    });
    return map;
  }, {}),
  shortcuts: emojies_shortcuts,
  enabled: [],
});
